import { render, staticRenderFns } from "./LeaveApproveSettings.vue?vue&type=template&id=130f097d"
import script from "./LeaveApproveSettings.vue?vue&type=script&lang=js"
export * from "./LeaveApproveSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports